import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { ApiService } from '../../services/api.service';
import { UiModeService } from '../../services/ui-mode.service';

@Component({
  selector: 'app-category-v2',
  templateUrl: './category-v2.component.html'
})
export class CategoryV2Component implements OnInit {
  public imageURL: string = 'https://keongkee.com.my/api/public/static';
  public defaultImage: string = 'https://keongkee.com.my/api/public/static/default.jpeg';

  shop: string;
  catId: string;

  category: any = null;
  subMenus: Array<any> = [];
  hasDirectDishes = false;

  loading = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private uiMode: UiModeService
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.uiMode.scrollToTop();
      this.shop = params.shop || this.uiMode.shopFromHost();
      this.catId = params.cat;
      this.fetch();
    });
  }

  fetch() {
    this.loading = true;
    this.apiService.fetchMenu(this.shop).subscribe(
      (data: Array<any>) => {
        const cats = data || [];
        this.category = cats.filter(c => c.id === this.catId)[0] || null;
        if (this.category) {
          this.subMenus = this.category.subMenuPayloadList || [];
          this.hasDirectDishes = (this.category.dishPayloadList || []).length > 0;
        }
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }

  goSubMenu(sub) {
    this.router.navigate(['/v2/dishes'], { queryParams: { shop: this.shop, cat: this.catId, sub: sub.id } });
  }

  goDirectDishes() {
    this.router.navigate(['/v2/dishes'], { queryParams: { shop: this.shop, cat: this.catId } });
  }

  back() {
    this.router.navigate(['/v2/menu'], { queryParams: { shop: this.shop } });
  }

  onImgError(event) {
    event.target.src = this.defaultImage;
  }
}
